module.exports = {
 
  MEDIA_ATTACHING: 'wfsMediaAttaching',  
 
  MEDIA_ATTACHED: 'wfsMediaAttached',
 
  FRAG_LOADING: 'wfsFragLoading',

  BUFFER_CREATED: 'wfsBufferCreated', 

  BUFFER_APPENDING: 'wfsBufferAppending',

  BUFFER_RESET: 'wfsBufferReset', 

  FRAG_PARSING_DATA: 'wfsFragParsingData',
 
  FRAG_PARSING_INIT_SEGMENT: 'wfsFragParsingInitSegment',
//------------------------------------------
  H264_DATA_PARSING: 'wfsH264DataParsing',

  H264_DATA_PARSED: 'wfsH264DataParsed',
//------------------------------------------
  WEBSOCKET_ATTACHED: 'wfsWebsocketAttached',

  WEBSOCKET_ATTACHING: 'wfsWebsocketAttaching',

  WEBSOCKET_DATA_UPLOADING: 'wfsWebsocketDataUploading',

  WEBSOCKET_MESSAGE_SENDING: 'wfsWebsocketMessageSending',   
//------------------------------------------
  FILE_HEAD_LOADING: 'wfsFileHeadLoading',

  FILE_HEAD_LOADED: 'wfsFileHeadLoaded',

  FILE_DATA_LOADING: 'wfsFileDataLoading',

  FILE_DATA_LOADED: 'wfsFileDataLoaded',

  FILE_PARSING_DATA: 'wfsFileParsingData',
//------------------------------------------

  CAMERA_INFO_RECEIVED: 'wfsCameraInfoReceived'
//------------------------------------------

};
